  export const parseYear = (year)=>{
    if(isNaN(year)){
        var res = year.split("-");
        return Number(res[0])
      } else {
        return Number(year)
      }
}